export default (mountAutoComplete) =>
  mountAutoComplete({
    cocoonSelector: `[data-behaviour="roles-list-user-firms"],[data-behaviour="roles-list-user-customers"],[data-behaviour="roles-list-user-externals"],[data-behaviour="companies-list"],[data-behaviour="subsidiary-companies-list"]`,
    path: () =>
      Silverfin.Routes.autocomplete_companies_path({
        firm_id: Silverfin.currentFirmId,
      }),
    textfieldSelector: '[data-behaviour="company-autocomplete"]',
  })
